import { createFileRoute, redirect } from "@tanstack/react-router";

/** The shop became part of the offer (ADR 0035): old links and bookmarks land on its orders. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders
export const Route = createFileRoute("/(private)/shop/orders/")({
  beforeLoad: () => {
    throw redirect({ to: "/offer/orders", replace: true });
  },
});
